<!---horizontal-->
<ng-container *ngIf="type === 'horizontal'">
	<div class="playlist-card fx-column fx-start-stretch">
		<ng-container
			*ngIf="playlistData?.forwarderName || ![null, undefined, ''].includes(playlistData?.forwarderThumbnail)">
			<div class="forward-user-block fx-row fx-start-center">
				<mat-icon class="forward-icon" svgIcon="forward_content"></mat-icon>
				<ng-container *ngIf="![null, undefined, ''].includes(playlistData?.forwarderThumbnail)">
					<img [src]="playlistData?.forwarderThumbnail" (error)="gfService.setErrorImage($event, 'man')">
				</ng-container>
				<ng-container *ngIf="playlistData?.forwarderName">
					<span class="sub-caption-1">{{playlistData?.forwarderName}}</span>
				</ng-container>
			</div>
		</ng-container>
		<div class="fx-row fx-start-stretch">
			<ng-container *ngIf="![null, undefined, ''].includes(playlistData?.thumbnail)">
				<div class="fx-row fx-start-start fx-no-grow fx-no-shrink">
					<div class="thumbnail-block fx-row">
						<div class="thumbnail fx-row fx-center-center" (click)="info(playlistData)">
							<ng-container *ngIf="![null, undefined, ''].includes(playlistData?.thumbnail)">
								<img [src]="playlistData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" alt="">
							</ng-container>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container
				*ngIf="playlistData?.type || playlistData?.status || playlistData?.userThumbnail || playlistData?.title || playlistData?.description || playlistData?.creator  || ![null, undefined].includes(playlistData?.rating) || ![null, undefined].includes(playlistData?.commentsCount)">
				<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
					<ng-container *ngIf="(playlistData?.type || playlistData?.status)">
						<div class="patch-block fx-row fx-space-between-center">
							<ng-container *ngIf="playlistData?.type" [ngTemplateOutlet]="typePatch"
								[ngTemplateOutletContext]="{data: playlistData}">
							</ng-container>
							<div class="fx-row fx-start-center">
								<ng-container *ngIf="playlistData?.status" [ngTemplateOutlet]="statusPatch"
									[ngTemplateOutletContext]="{data: playlistData}">
								</ng-container>
								<ng-container *ngIf="playlistData?.removable">
									<button class="delete-btn" mat-icon-button #actionBtn
										(click)="close({'actionElement': actionBtn, 'data': playlistData})">
										<mat-icon svgIcon="delete"></mat-icon>
									</button>
								</ng-container>
							</div>
						</div>
					</ng-container>
					<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
						<ng-container *ngIf="playlistData?.title || playlistData?.description">
							<div class="fx-column fx-start-start fx-grow fx-shrink">
								<ng-container *ngIf="playlistData?.title">
									<p class="card-title linkable" (click)="info(playlistData)">{{playlistData?.title}}</p>
								</ng-container>
								<ng-container *ngIf="playlistData?.description">
									<p class="card-description">{{playlistData?.description}}</p>
								</ng-container>
							</div>
						</ng-container>
						<ng-container
							*ngIf="playlistData?.creator || playlistData?.date || ![null, undefined].includes(playlistData?.rating) || ![null, undefined].includes(playlistData?.commentsCount)">
							<div class="fx-row-wrap fx-space-between-center">
								<!-- <ng-container
								*ngIf="playlistData?.actions?.length || playlistData?.creator || ![null, undefined].includes(playlistData?.userThumbnail)"> -->
								<ng-container *ngIf="playlistData?.creator || playlistData?.date">
									<div class="fx-row fx-start-center">
										<ng-container *ngIf="playlistData?.creator">
											<div (click)="profileInfo(playlistData)" class="user-pic fx-row fx-start-center">
												<ng-container *ngIf="![null, undefined].includes(playlistData?.userThumbnail)">
													<img [src]="playlistData?.userThumbnail" alt=""
														(error)="gfService.setErrorImage($event, 'man')">
												</ng-container>
												<span class="sub-caption-1">{{playlistData?.creator}}</span>
											</div>
										</ng-container>
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px" class="playlist-item-count">
											<mat-icon svgIcon="resource"></mat-icon>
											<span>{{playlistData?.playlistItemCount || 0}}</span>
										</div>
									</div>
								</ng-container>
								<ng-container
									*ngIf="![null, undefined].includes(playlistData?.rating) || ![null, undefined].includes(playlistData?.commentsCount)">
									<div class="fx-row fx-start-center">
										<ng-container *ngIf="![null, undefined].includes(playlistData?.rating)">
											<div class="playlist-rating">
												<ng-container *ngFor="let rate of playlistData?.ratingData">
													<ng-container *ngIf="isInt(rate) && rate !== 0">
														<mat-icon>star</mat-icon>
													</ng-container>
													<ng-container *ngIf="isFloat(rate) && rate !== 0">
														<mat-icon>star_half</mat-icon>
													</ng-container>
													<ng-container *ngIf="rate === 0">
														<mat-icon>star_border</mat-icon>
													</ng-container>
												</ng-container>
											</div>
										</ng-container>
										<ng-container *ngIf="![null, undefined].includes(playlistData?.commentsCount)">
											<app-badge [count]="playlistData?.commentsCount | abbreviateNumber" svgIcon="comments" size="16px"
												class="playlist-comment-count"></app-badge>
										</ng-container>
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
			<!-- <div *ngIf="playlistData?.removable" class="cancel" fxLayoutAlign="center center">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': playlistData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div> -->
		</div>
	</div>
</ng-container>
<!----end-->
<!---vertical---->
<ng-container *ngIf="type === 'vertical'">
	<div class="playlist-card vertical fx-column fx-start-stretch">
		<ng-container
			*ngIf="playlistData?.forwarderName || ![null, undefined, ''].includes(playlistData?.forwarderThumbnail)">
			<div class="forward-user-block fx-row fx-start-center">
				<mat-icon class="forward-icon" svgIcon="forward_content"></mat-icon>
				<ng-container *ngIf="![null, undefined, ''].includes(playlistData?.forwarderThumbnail)">
					<img [src]="playlistData?.forwarderThumbnail" (error)="gfService.setErrorImage($event, 'man')">
				</ng-container>
				<ng-container *ngIf="playlistData?.forwarderName">
					<span class="sub-caption-1">{{playlistData?.forwarderName}}</span>
				</ng-container>
			</div>
		</ng-container>
		<div class="fx-column fx-start-stretch fx-grow fx-shrink">
			<ng-container *ngIf="![null, undefined, ''].includes(playlistData?.thumbnail)">
				<div class="thumbnail-block">
					<div class="thumbnail  fx-row fx-center-center" (click)="info(playlistData)">
						<ng-container *ngIf="![null, undefined, ''].includes(playlistData?.thumbnail)">
							<img [src]="playlistData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" alt="">
						</ng-container>
					</div>
				</div>
			</ng-container>
			<ng-container
				*ngIf="playlistData?.type || playlistData?.status || playlistData?.userThumbnail || playlistData?.title || playlistData?.description || playlistData?.creator  || ![null, undefined].includes(playlistData?.rating) || ![null, undefined].includes(playlistData?.commentsCount)">
				<div class="content-block  fx-column fx-start-stretch fx-grow fx-shrink">
					<ng-container *ngIf="(playlistData?.type || playlistData?.status)">
						<div class="patch-block fx-row fx-space-between-center">
							<ng-container *ngIf="playlistData?.type" [ngTemplateOutlet]="typePatch"
								[ngTemplateOutletContext]="{data: playlistData}">
							</ng-container>
							<ng-container *ngIf="playlistData?.status" [ngTemplateOutlet]="statusPatch"
								[ngTemplateOutletContext]="{data: playlistData}">
							</ng-container>
						</div>
					</ng-container>
					<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
						<ng-container *ngIf="playlistData?.title || playlistData?.description">
							<div class="title-block fx-column fx-start-start fx-grow fx-shrink">
								<ng-container *ngIf="playlistData?.title">
									<p class="card-title linkable" (click)="info(playlistData)">{{playlistData?.title}}</p>
								</ng-container>
							</div>
						</ng-container>
						<ng-container
							*ngIf="playlistData?.creator || playlistData?.date || ![null, undefined].includes(playlistData?.rating) || ![null, undefined].includes(playlistData?.commentsCount) || ![null, undefined].includes(playlistData?.playlistItemCount)">
							<div class="fx-column fx-start-stretch fx-grow fx-shrink">
								<ng-container
									*ngIf="playlistData?.creator || playlistData?.date || ![null, undefined].includes(playlistData?.playlistItemCount)">
									<div class="user-block fx-row-wrap"
										[ngClass]="(((playlistData?.creator || ![null, undefined].includes(playlistData?.userThumbnail)) && playlistData?.courseDuration) || ((playlistData?.creator || ![null, undefined].includes(playlistData?.userThumbnail)) && playlistData?.date) || (playlistData?.courseDuration && playlistData?.date)) ? 'fx-space-between-center' : 'fx-end-center'">
										<ng-container *ngIf="playlistData?.creator">
											<div (click)="profileInfo(playlistData)" class="user-pic fx-row fx-start-center">
												<ng-container *ngIf="![null, undefined].includes(playlistData?.userThumbnail)">
													<img [src]="playlistData?.userThumbnail" alt=""
														(error)="gfService.setErrorImage($event, 'man')">
												</ng-container>
												<span class="sub-caption-1">{{playlistData?.creator}}</span>
											</div>
										</ng-container>
										<ng-container *ngIf="![null, undefined].includes(playlistData?.playlistItemCount)">
											<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px" class="playlist-item-count">
												<mat-icon svgIcon="playlist"></mat-icon>
												<span>{{playlistData?.playlistItemCount}}</span>
											</div>
										</ng-container>
									</div>
								</ng-container>
								<ng-container
									*ngIf="![null, undefined].includes(playlistData?.rating) || ![null, undefined].includes(playlistData?.commentsCount)">
									<div class="fx-row-wrap"
										[ngClass]="((![null, undefined].includes(playlistData?.rating) && ![null, undefined].includes(playlistData?.commentsCount))) ? 'fx-space-between-center' : 'fx-end-center'">
										<ng-container *ngIf="![null, undefined].includes(playlistData?.rating)">
											<div class="playlist-rating">
												<ng-container *ngFor="let rate of playlistData?.ratingData">
													<ng-container *ngIf="isInt(rate) && rate !== 0">
														<mat-icon>star</mat-icon>
													</ng-container>
													<ng-container *ngIf="isFloat(rate) && rate !== 0">
														<mat-icon>star_half</mat-icon>
													</ng-container>
													<ng-container *ngIf="rate === 0">
														<mat-icon>star_border</mat-icon>
													</ng-container>
												</ng-container>
											</div>
										</ng-container>
										<ng-container *ngIf="![null, undefined].includes(playlistData?.commentsCount)">
											<app-badge [count]="playlistData?.commentsCount | abbreviateNumber" svgIcon="comments" size="16px"
												class="playlist-comment-count"></app-badge>
										</ng-container>
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
			<div *ngIf="playlistData?.removable" class="cancel fx-center-center">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': playlistData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>
<!---end-->

<!---minimal-->
<ng-container *ngIf="type === 'minimal'">
	<div class="playlist-card minimal fx-column fx-start-stretch">
		<div class="fx-row fx-start-stretch fx-grow fx-shrink">
			<div class="fx-row fx-start-stretch fx-grow fx-shrink">
				<ng-container *ngIf="![null, undefined, ''].includes(playlistData?.thumbnail)">
					<div class="fx-row fx-start-start fx-no-grow fx-no-shrink">
						<div class="minimal-thumbnail-block fx-row">
							<div class="minimal-thumbnail fx-row fx-center-center" (click)="info(playlistData)">
								<ng-container *ngIf="![null, undefined, ''].includes(playlistData?.thumbnail)">
									<img [src]="playlistData?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" alt="">
								</ng-container>
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="playlistData?.type || playlistData?.title ">
					<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
						<ng-container *ngIf="(playlistData?.type)">
							<div class="patch-block fx-row fx-space-between-center">
								<ng-container *ngIf="playlistData?.type" [ngTemplateOutlet]="typePatch"
									[ngTemplateOutletContext]="{data: playlistData}">
								</ng-container>
							</div>
						</ng-container>
						<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
							<ng-container *ngIf="playlistData?.title">
								<div class="fx-column fx-start-start fx-grow fx-shrink">
									<ng-container *ngIf="playlistData?.title">
										<p class="card-title linkable" (click)="info(playlistData)">{{playlistData?.title}}</p>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="playlistData?.removable" class="cancel" fxLayoutAlign="center center">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': playlistData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>
<!----end-->

<ng-template #typePatch let-data="data">
	<div class="content-type" fxLayoutAlign="start start">
		<div class="patch sub-txt-patch">{{data?.type}}</div>
	</div>
</ng-template>

<ng-template #statusPatch let-data="data">
	<p class="sub-txt-patch" [ngClass]="playlistData?.statusCode">{{data?.status}}</p>
</ng-template>
